import { render, staticRenderFns } from "./ListTitleSkeleton.vue?vue&type=template&id=1f18c8bc&scoped=true"
import script from "./ListTitleSkeleton.vue?vue&type=script&lang=js"
export * from "./ListTitleSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ListTitleSkeleton.vue?vue&type=style&index=0&id=1f18c8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f18c8bc",
  null
  
)

export default component.exports